export const adMovies = {
  'X-RapidAPI-Host': "advanced-movie-search.p.rapidapi.com",
  'X-RapidAPI-Key': process.env.REACT_APP_RAPIDAPI_APP_DEFAULT_KEY
};
export const dadJokes = {
  'X-RapidAPI-Host': "dad-jokes.p.rapidapi.com",
  'X-RapidAPI-Key': process.env.REACT_APP_RAPIDAPI_APP_DEFAULT_KEY
};